import { useEffect, useState, useRef } from 'react';
import 'chartjs-adapter-moment';
import { Line } from "react-chartjs-2";
import Hammer from 'hammerjs' 
import zoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  ChartConfiguration,
  LineController,
  BarController,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(
  LineController,
  BarController,
  CategoryScale,
  LinearScale,
  TimeScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

export default function Weathergraph(props) {
  const [data, setdata] = useState({ options: {}, graphdata: { datasets: [] } });
  const chartRef = useRef(null);
  const handleResetZoom = () => {
    if (chartRef && chartRef.current) {
      chartRef.current.resetZoom();
    }
  };

  useEffect(() => {
    if (!props.data) return;
    let label = props.data["datetime"];
    let data1 = props.data.rain;

    let data = {
      labels: label,
      datasets:
        [
          {
            label: "雨量",
            type: "bar",
            data: data1,
            borderColor: "#4472C4",
            backgroundColor: "#4472C4",
            borderWidth: 1,
            pointRadius: 1,
            yAxisID: 'y',
          },
        ],
    };
    
    let options = {
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'hour',
            stepSize: 1,
            displayFormats: {
                'hour': 'HH:mm'
            }
          },
          scaleLabel: {
            display: true,
          },
          grid: {
            offset: false,
          }
        },
        y: {
          display: true,
          min: 0,
          max: 0.5,
          position: 'left',
          ticks: {
            display: true,
          },
          title: {
            display: true,
            text: '雨量(mm/min)',
          },
        },
        y2: {
          display: true,
          min: 0,
          max: 0.5,
          position: 'right',
          ticks: {
            display: true,
          },
          title: {
            display: true,
            text: '雨量(mm/min)',
          },
        },
      },
      plugins: {
        zoom: {
          pan: {
            enabled: true,
            mode: 'xy',
            scaleMode: 'xy',
            modifierKey: "ctrl",
          },
          zoom: {
            wheel: {
              enabled: false,
            },
            pinch: {
              enabled: true,
            },
            drag: {
              enabled: true,
            },
            mode: 'xy',
            scaleMode: 'xy'
          }
        }
      }
    };
    setdata({ options: options, graphdata: data });
  }, [props.data]);

  return (
      <div style={{ height: props.height,position:"relative" }}  onDoubleClick={handleResetZoom}>
        <Line
          ref={chartRef}
          data={data.graphdata}
          options={data.options}
        />
        <div style={{position: "absolute", right:"1em", bottom:"1em", fontSize:"small"}}>(時刻)</div>
      </div>
  );
}
